//
export default [
    {
        field: 'rut',
        label: 'RUT',
        value: ''
    },
    {
        field: 'names',
        label: 'Nombres',
        value: ''
    },
    {
        field: 'last_name1',
        label: 'Primer apellido',
        value: ''
    },
    {
        field: 'last_name2',
        label: 'Segundo apellido',
        value: ''
    },
    {
        field: 'email',
        label: 'Correo electrónico',
        value: ''
    },
    {
        field: 'hr_prevision_id',
        label: 'Prevision',
        value: [],
        options: []
    },
]